import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Heading, Button, Flex } from 'rebass';
import { FiXOctagon } from 'react-icons/fi';
// import Layout from '@/components/Layout';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { patch } from 'utils/api';
import Banner from 'app/payment/Banner';
import { getApiBase } from 'utils/api-base';
import { FieldText } from 'babys-first-year/SignUp';
import { useLogin } from 'auth/hooks';

function PasswordResetForm({ secret, id, onSuccess }) {
  const login = useLogin();

  const handleSubmit = async ({ password }) => {
    const response = await patch(`/v3/password_resets/${id}`, {
      password_reset_token: secret,
      password,
    });

    // The PATCH response is the account's identifier resource, which carries its
    // email — reused with the password just set to log straight in (POST
    // /v3/login), the same path LoginSignup/SignUp/LoginScreen already use.
    const email = response?.data?.initial?.data?.attributes?.email;

    if (email) {
      try {
        await login({ email, password });
      } catch (err) {
        // The password change itself already succeeded even if this auto-login
        // call fails — don't block on it, just send them through as normal.
      }
    }

    onSuccess();
  };

  return (
    <Formik
      initialValues={{ password: '', confirmPassword: '' }}
      validationSchema={Yup.object().shape({
        password: Yup.string().min(6).required(),
        confirmPassword: Yup.string()
          .required()
          .oneOf([Yup.ref('password'), null], 'Passwords must match'),
      })}
      onSubmit={handleSubmit}
    >
      {({ isSubmitting }) => (
        <Form>
          <FieldText name="password" label="New Password" type="password" justifyContent="left" ml={0} />
          <FieldText
            name="confirmPassword"
            label="Confirm New Password"
            type="password"
            justifyContent="left"
            ml={0}
          />
          <Button disabled={isSubmitting} type="submit" variant="primary">
            Change Password
          </Button>
        </Form>
      )}
    </Formik>
  );
}

function PasswordResetPage() {
  const params = useParams();
  const { push } = useHistory();

  const { id } = params;
  const [secret, setSecret] = useState(null);
  const [error, setError] = useState(null);

  async function getRestPasswordDetails() {
    const request = new Request(`${getApiBase('v3')}/password_resets/${id}`);
    const response = await fetch(request);
    if (response.status === 200) {
      const { data } = await response.json();

      setSecret(data.attributes.secret);
    } else {
      setError('Token Expired please reset password again');
    }
  }

  useEffect(() => {
    if (id) getRestPasswordDetails();
  }, [id]);

  return (
    <Flex flexDirection="column" py={4} width="100%" maxWidth={480} mx="auto">
      {error && (
        <Banner
          icon={FiXOctagon}
          color="pinks.5"
          bg="pinks.1"
          p={3}
          heading="Request Failed"
          text={error}
          mb={4}
          size="small"
        />
      )}
      {secret && (
        <>
          <Heading pb={4}
            color="codGrey"
            fontFamily="Bitter"
            fontSize={[24, 28]}
            lineHeight={["34px", "38px"]}
            letterSpacing="-0.6"
            myx={2}
          >Reset Password</Heading>

          <PasswordResetForm secret={secret} id={id} onSuccess={() => push('/')} />
        </>
      )}
    </Flex>
  );
}

export default PasswordResetPage;
